/* Cotizador */
const MONEY_REGEX = /\B(?=(\d{3})+(?!\d))/g;

const total_precio_input                          = document.querySelector("input[name='total-precio']");
const total_precio_html                           = document.querySelector(".precio");
// Buttons
const button_submit                               = document.querySelector(".botones .agregar");
const button_reset                                = document.querySelector(".botones .volver");
// Acordeon
const cotiza_titles                               = document.querySelectorAll(".title-select-h1");
const cotiza_subtitles                            = document.querySelectorAll(".title-select-h4");
const cotiza_options                              = document.querySelectorAll(".option");
const label_radios                                = document.querySelectorAll(".label-colores");
const region_select                               = document.querySelector(".region-select");
const region_comuna                               = document.querySelector(".region-comuna");
const region_direccion                            = document.querySelector(".region-direccion");
const radio_container                             = document.querySelector(".radio-container");
const radio_message_container                     = document.querySelector(".radio-message-container");
const address_container                           = document.querySelector(".address-container");
const comunas_select                              = document.querySelector(".region-comunas");
const preview_image                               = document.querySelector(".inner-image");
const preview_image_zoom                          = document.querySelector(".inner-image-zoom");
// Formulario
const input_cortina_tipos                         = document.querySelectorAll("input[name='cortina-tipos']");
const input_sucursal                              = document.querySelector("select[name='sucursal']");
const input_ancho                                 = document.querySelector("input[name='ancho']");
const input_alto                                  = document.querySelector("input[name='alto']");
const input_tela_tipos                            = document.querySelectorAll("input[name='tela-tipos']");
const input_tela_suboptions                       = document.querySelectorAll("input[name='tela-suboptions']");
const input_tela_opcion_colores                   = document.querySelectorAll("input[name='tela-opcion-colores']");
const input_accionamiento_tipos                   = document.querySelectorAll("input[name='accionamiento-tipos']");
const input_caida_sentidos                        = document.querySelectorAll("input[name='caida-sentidos']");
const input_cantidad_panos                        = document.querySelectorAll("input[name='cantidad-panos']");
const input_tipo_cortinas                         = document.querySelectorAll("input[name='tipo-cortinas']");
const input_mando_posiciones                      = document.querySelectorAll("input[name='mando-posiciones']");
const input_color_accesorios                      = document.querySelectorAll("input[name='color-accesorios']");
const input_cortina_instalaciones                 = document.querySelectorAll("input[name='cortina-instalaciones']");
const input_instalacion_tipos                     = document.querySelectorAll("input[name='instalacion-tipos']");
const input_instalacion_region                    = document.querySelector("select[name='instalacion-region']");
const input_instalacion_comuna                    = document.querySelector("select[name='instalacion-comuna']");
const input_instalacion_direccion                 = document.querySelector("input[name='instalacion-direccion']");
const input_nombre                                = document.querySelector("#nombre");
const input_mensaje                               = document.querySelector("#mensaje");
const reset_button                                = document.querySelector(".botones .btn.volver");
// Cotización
const cotizacion_cortina_tipo                     = document.querySelector(".val-cortina-tipo");
const cotizacion_ancho                            = document.querySelector(".val-ancho");
const cotizacion_alto                             = document.querySelector(".val-alto");
const cotizacion_tela_tipo                        = document.querySelector(".val-tela-tipo");
const cotizacion_tela_suboption                   = document.querySelector(".val-tela-suboption");
const cotizacion_cantidad_pano                    = document.querySelector(".val-cantidad-pano");
const cotizacion_tipo_cortina                     = document.querySelector(".val-tipo-cortina");
const cotizacion_accionamiento_tipo               = document.querySelector(".val-accionamiento-tipo");
const cotizacion_caida_sentido                    = document.querySelector(".val-caida-sentido");
const cotizacion_color_accesorio                  = document.querySelector(".val-color-accesorio");
const cotizacion_posicion_mando                   = document.querySelector(".val-posicion-mando");
const cotizacion_instalacion_cortina              = document.querySelector(".val-instalacion-cortina");
const cotizacion_instalacion                      = document.querySelector(".val-instalacion");
// Formulario Cotizado
const form_cotizado_cortina_tipo                  = document.querySelector("input[name='form-cortina-tipo']");
const form_cotizado_ancho                         = document.querySelector("input[name='form-ancho']");
const form_cotizado_alto                          = document.querySelector("input[name='form-alto']");
const form_cotizado_tela_tipo                     = document.querySelector("input[name='form-tela-tipo']");
const form_cotizado_tela_suboption                = document.querySelector("input[name='form-tela-suboption']");
const form_cotizado_tela_opcion_color             = document.querySelector("input[name='form-tela-opcion-color']");
const form_cotizado_accionamiento_tipo            = document.querySelector("input[name='form-accionamiento-tipo']");
const form_cotizado_caida_sentido                 = document.querySelector("input[name='form-caida-sentido']");
const form_cotizado_cantidad_pano                 = document.querySelector("input[name='form-cantidad-pano']");
const form_cotizado_tipo_cortina                  = document.querySelector("input[name='form-tipo-cortina']");
const form_cotizado_mando_posicion                = document.querySelector("input[name='form-mando-posicion']");
const form_cotizado_color_accesorio               = document.querySelector("input[name='form-color-accesorio']");
const form_cotizado_cortina_instalacion           = document.querySelector("input[name='form-cortina-instalacion']");
const form_cotizado_instalacion                   = document.querySelector("input[name='form-instalacion']");
const form_cotizado_instalacion_region            = document.querySelector("input[name='form-instalacion-region']");
const form_cotizado_instalacion_comuna            = document.querySelector("input[name='form-instalacion-comuna']");
const form_cotizado_instalacion_direccion         = document.querySelector("input[name='form-instalacion-direccion']");
const form_cotizado_nombre                        = document.querySelector("input[name='form-nombre']");
const form_cotizado_mensaje                       = document.querySelector("input[name='form-mensaje']");
const form_cotizado_homologado_venta              = document.querySelector("input[name='form-homologado-venta']");
// Hidden Form Productos Madera
const hidden_form_producto_anillo_madera          = document.querySelector("input[name='product-anillo-madera']");
const hidden_form_producto_barra_madera           = document.querySelector("input[name='product-barra-madera']");
const hidden_form_producto_base_madera            = document.querySelector("input[name='product-base-madera']");
const hidden_form_producto_borla_madera           = document.querySelector("input[name='product-borla-madera']");
const hidden_form_producto_boton_madera           = document.querySelector("input[name='product-boton-madera']");
const hidden_form_producto_boton_escalera_madera  = document.querySelector("input[name='product-boton-escalera-madera']");
const hidden_form_producto_bracket_central_madera = document.querySelector("input[name='product-bracket-central-madera']");
const hidden_form_producto_bracket_lateral_madera = document.querySelector("input[name='product-bracket-lateral-madera']");
const hidden_form_producto_cabezal_madera         = document.querySelector("input[name='product-cabezal-madera']");
const hidden_form_producto_cenefa_madera          = document.querySelector("input[name='product-cenefa-madera']");
const hidden_form_producto_clip_1_madera          = document.querySelector("input[name='product-clip-1-madera']");
const hidden_form_producto_clip_2_madera          = document.querySelector("input[name='product-clip-2-madera']");
const hidden_form_producto_clip_cenefa_madera     = document.querySelector("input[name='product-clip-cenefa-madera']");
const hidden_form_producto_cuerda_madera          = document.querySelector("input[name='product-cuerda-madera']");
const hidden_form_producto_freno_madera           = document.querySelector("input[name='product-freno-madera']");
const hidden_form_producto_lama_madera            = document.querySelector("input[name='product-lama-madera']");
const hidden_form_producto_madera_1_madera        = document.querySelector("input[name='product-madera-1-madera']");
const hidden_form_producto_madera_2_madera        = document.querySelector("input[name='product-madera-2-madera']");
const hidden_form_producto_piola_madera           = document.querySelector("input[name='product-piola-madera']");
const hidden_form_producto_riel_madera            = document.querySelector("input[name='product-riel-madera']");
const hidden_form_producto_rodillo_madera         = document.querySelector("input[name='product-rodillo-madera']");
const hidden_form_producto_tapa_madera            = document.querySelector("input[name='product-tapa-madera']");
const hidden_form_producto_varilla_madera         = document.querySelector("input[name='product-varilla-madera']");
const hidden_form_producto_confeccion_madera      = document.querySelector("input[name='product-confeccion-madera']");
const hidden_form_producto_instalacion_madera     = document.querySelector("input[name='producto-instalacion-madera']");
const hidden_form_producto_peso_envio_madera      = document.querySelector("input[name='producto-peso-envio-madera']");
// Hidden Productos Madera ?
let hidden_producto_anillo_madera                 = document.querySelector(".madera-products .product-anillo-madera");
let hidden_producto_barra_madera                  = document.querySelector(".madera-products .product-barra-madera");
let hidden_producto_base_madera                   = document.querySelector(".madera-products .product-base-madera");
let hidden_producto_borla_madera                  = document.querySelector(".madera-products .product-borla-madera");
let hidden_producto_boton_madera                  = document.querySelector(".madera-products .product-boton-madera");
let hidden_producto_boton_escalera_madera         = document.querySelector(".madera-products .product-boton-escalera-madera");
let hidden_producto_bracket_central_madera        = document.querySelector(".madera-products .product-bracket-central-madera");
let hidden_producto_bracket_lateral_madera        = document.querySelector(".madera-products .product-bracket-lateral-madera");
let hidden_producto_cabezal_madera                = document.querySelector(".madera-products .product-cabezal-madera");
let hidden_producto_cenefa_madera                 = document.querySelector(".madera-products .product-cenefa-madera");
let hidden_producto_clip_1_madera                 = document.querySelector(".madera-products .product-clip-1-madera");
let hidden_producto_clip_2_madera                 = document.querySelector(".madera-products .product-clip-2-madera");
let hidden_producto_clip_cenefa_madera            = document.querySelector(".madera-products .product-clip-cenefa-madera");
let hidden_producto_cuerda_madera                 = document.querySelector(".madera-products .product-cuerda-madera");
let hidden_producto_freno_madera                  = document.querySelector(".madera-products .product-freno-madera");
let hidden_producto_lama_madera                   = document.querySelectorAll(".madera-products .product-lama-madera");
let hidden_producto_madera_1_madera               = document.querySelector(".madera-products .product-madera-1-madera");
let hidden_producto_madera_2_madera               = document.querySelector(".madera-products .product-madera-2-madera");
let hidden_producto_piola_madera                  = document.querySelector(".madera-products .product-piola-madera");
let hidden_producto_riel_madera                   = document.querySelector(".madera-products .product-riel-madera");
let hidden_producto_rodillo_madera                = document.querySelector(".madera-products .product-rodillo-madera");
let hidden_producto_tapa_madera                   = document.querySelector(".madera-products .product-tapa-madera");
let hidden_producto_varilla_madera                = document.querySelector(".madera-products .product-varilla-madera");
let hidden_producto_confeccion_madera             = document.querySelector(".product-confeccion-madera");
let hidden_producto_instalacion_madera            = document.querySelector(".tradicional-instalacion-tradicional");
// print cotización area
const hidden_cotizacion_area                      = document.querySelector(".inner-cotizacion-content");
const cotiza_container                            = document.querySelector(".cotiza-cortina");

async function initCotizadorBootstrapData() {
  if (typeof fetchCotizadorBootstrap !== "function") {
    console.error("No existe helper fetchCotizadorBootstrap");
    return;
  }

  const bootstrap = await fetchCotizadorBootstrap({ container: cotiza_container });
  if (bootstrap && typeof applyCotizadorBootstrapToDom === "function") {
    applyCotizadorBootstrapToDom(bootstrap);
  }
}

// Massive Event Listeners
function addEventListenerToCollection(collection, event, callback, ...args) {
  if (collection && collection.length > 0) {
    collection.forEach(item => {
      item.addEventListener(event, function(e) {
        callback.apply(this, [e, ...args]);
      });
    });
  }
}

button_submit.addEventListener("click", submitCotizacion);

// Acordeon
if (cotiza_titles.length > 0) {
  cotiza_titles.forEach(cotiza_title => {
    cotiza_title.addEventListener("click", toggleTitle);
  });
}

if (cotiza_subtitles.length > 0) {
  cotiza_subtitles.forEach(cotiza_subtitle => {
    cotiza_subtitle.addEventListener("click", toggleSubtitle);
  });
}

if (label_radios.length > 0) {
  label_radios.forEach(label_radio => {
    label_radio.addEventListener("click", activeLabelRadio);
  });
}

if (input_tela_suboptions.length > 0) {
  input_tela_suboptions.forEach(input_tela_suboption => {
    input_tela_suboption.addEventListener("click", activeTelaSuboption);
  });
}

addEventListenerToCollection(input_tela_opcion_colores, "change", setCotizacion, "telaOptionColor");

reset_button.addEventListener("click", resetForm);

if (region_select !== null) {
  region_select.addEventListener("change", setRegion);
}

// Onload
window.addEventListener("load", loadBase);

// Formulario
if (input_cortina_tipos.length > 0) {
  input_cortina_tipos.forEach(input_cortina_tipo => {
    input_cortina_tipo.addEventListener("change", setCotizacionCortinaTipo);
  });
}

if (input_ancho !== null) {
  input_ancho.addEventListener("change", setCotizacionAncho);
  input_ancho.addEventListener("blur", setCotizacionAncho);
}
if (input_alto !== null) {
  input_alto.addEventListener("change", setCotizacionAlto);
  input_alto.addEventListener("blur", setCotizacionAlto);
}

if (input_tela_tipos.length > 0) {
  input_tela_tipos.forEach(input_tela_tipo => {
    input_tela_tipo.addEventListener("click", setCotizacionTelaTipo);
    input_tela_tipo.addEventListener("change", setCotizacionTelaTipo);
  });
}

if (input_tela_suboptions.length > 0) {
  input_tela_suboptions.forEach(input_tela_suboption => {
    input_tela_suboption.addEventListener("change", setCotizacionTelaSuboption);
  });
}

addEventListenerToCollection(input_mando_posiciones, "change", setCotizacion, "posicionMando");

if (input_cortina_instalaciones.length > 0) {
  input_cortina_instalaciones.forEach(input_cortina_instalacion => {
    input_cortina_instalacion.addEventListener("change", setCotizacionInstalacionCortina);
  });
}

if (input_instalacion_tipos.length > 0) {
  input_instalacion_tipos.forEach(input_instalacion_tipo => {
    input_instalacion_tipo.addEventListener("change", setCotizacionInstalacionTipo);
  });
}

if (input_instalacion_region !== null) {
  input_instalacion_region.addEventListener("change", setCotizacionInstalacionRegion);
}
if (input_instalacion_comuna !== null) {
  input_instalacion_comuna.addEventListener("change", setCotizacionInstalacionComuna);
}
if (input_instalacion_direccion !== null) {
  input_instalacion_direccion.addEventListener("change", setCotizacionInstalacionDireccion);
}
if (input_instalacion_region !== null) {
  input_instalacion_direccion.addEventListener("input", setCotizacionInstalacionDireccion);
}

if (input_nombre !== null) {
  input_nombre.addEventListener("change", setCotizacionNombre);
}
if (input_mensaje !== null) {
  input_mensaje.addEventListener("change", setCotizacionMensaje);
}

// Acordeon
function toggleTitle(event) {
  closeAllTitles(this);
  let cotiza_content = this.nextElementSibling;
  this.classList.toggle("active");
  if (this.parentNode.classList.contains("active")) {
    this.parentNode.classList.remove("active");
    cotiza_content.style.maxHeight = null;
  } else {
    this.parentNode.classList.add("active");
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  }
}

function openTitle(object) {
  let cotiza_content = object.nextElementSibling;
  object.parentNode.classList.add("active");
  object.classList.add("active");
  cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
}

function openAllTitles() {
  cotiza_titles.forEach(object => {
    let cotiza_content = object.nextElementSibling;
    object.parentNode.classList.add("active");
    object.classList.add("active");
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  });
}

function closeTitle(object) {
  let cotiza_content = object.nextElementSibling;
  object.parentNode.classList.remove("active");
  object.classList.remove("active");
  cotiza_content.style.maxHeight = null;
}

function closeAllTitles($_this) {
  cotiza_titles.forEach(object => {
    if ($_this === undefined) {
      let cotiza_content = object.nextElementSibling;
      object.parentNode.classList.remove("active");
      object.classList.remove("active");
      cotiza_content.style.maxHeight = null;
    } else {
      if (object.dataset.optionNumber !== $_this.dataset.optionNumber) {
        let cotiza_content = object.nextElementSibling;
        object.parentNode.classList.remove("active");
        object.classList.remove("active");
        cotiza_content.style.maxHeight = null;
      }
    }
  });
}

function toggleSubtitle(event) {
  let cotiza_option = this.nextElementSibling;
  if (this.classList.contains("active")) {
    this.classList.remove("active");
    this.parentNode.classList.remove("active");
    cotiza_option.style.maxHeight = null;
  } else {
    this.classList.add("active");
    this.parentNode.classList.add("active");
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  }
}

function openSubtitle(object) {
  let cotiza_option = object.nextElementSibling;
  object.classList.add("active");
  if (cotiza_option.style.maxHeight) {
    cotiza_option.style.maxHeight = null;
  } else {
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  }
}

function openAllSubtitles() {
  cotiza_subtitles.forEach(object => {
    let cotiza_option = object.nextElementSibling;
    object.classList.add("active");
    if (cotiza_option.style.maxHeight) {
      cotiza_option.style.maxHeight = null;
    } else {
      cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
    }
  });
}

function closeSubtitle(object) {
  let cotiza_option = object.nextElementSibling;
  object.classList.remove("active");
  if (cotiza_option.style.maxHeight) {
    cotiza_option.style.maxHeight = null;
  } else {
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  }
}

function closeAllSubtitles() {
  cotiza_subtitles.forEach(object => {
    let cotiza_option = object.nextElementSibling;
    object.classList.remove("active");
    if (cotiza_option.style.maxHeight) {
      cotiza_option.style.maxHeight = null;
    } else {
      cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
    }
  });
}

function activeLabelRadio(event) {
  let node_clicked = this.nodeName;
  switch(node_clicked) {
    case 'IMG':
      if (this.parentNode.parentNode.parentNode.classList.contains("active")) {
        turnOffRadios();
        this.parentNode.classList.add("active");
        turnOffSuboptions();
        this.parentNode.parentNode.parentNode.classList.add("active");
      }
      break;
    case 'LABEL':
      if (this.parentNode.parentNode.classList.contains("active")) {
        turnOffRadios();
        this.classList.add("active");
        turnOffSuboptions();
        this.parentNode.parentNode.classList.add("active");
      }
      break;
    case 'SPAN':
      if (this.parentNode.parentNode.parentNode.classList.contains("active")) {
        let screen_plus = document.getElementById("screen_plus");
        turnOffRadios();
        this.parentNode.classList.add("active");
        turnOffSuboptions();
        this.parentNode.parentNode.parentNode.classList.add("active");
        screen_plus.setAttribute("checked", "checked");
      }
      break;
  }
}

function activeTelaSuboption(event) {
  turnOffSuboptions();
  turnOffRadios();
  this.parentNode.parentNode.parentNode.classList.add("active");
  let flag = true;
  document.querySelectorAll(".suboptions.active .label-colores").forEach(label_radio => {
    if (window.getComputedStyle(label_radio).display !== "none" && flag) {
      flag = false;
      label_radio.classList.add("active");
      label_radio.previousElementSibling.checked = true;
      label_radio.previousElementSibling.dispatchEvent(new Event('change'));
      return false;
    }
  });
}

function turnOffRadios() {
  document.querySelectorAll(".label-colores").forEach(label_radio => {
    label_radio.classList.remove("active");
  });
}

function turnOffSuboptions() {
  input_tela_suboptions.forEach(input_tela_suboption => {
    input_tela_suboption.parentNode.parentNode.parentNode.classList.remove("active");
  });
}

// Onload
async function loadBase() {
  await initCotizadorBootstrapData();
  hydrateBootstrapMaderaComponents();
  refreshHiddenProductoMaderaRefs();
  let reset_form = findGetParameter("reset_form");
  if (reset_form !== null) {
    if (reset_form == "true") {
      let top_element = document.querySelector(".cortina-type").getBoundingClientRect().top;
      let header_height = document.querySelector("#shopify-section-header header").offsetHeight;
      window.scrollBy({
        top: top_element - header_height, // could be negative value
        left: 0,
        behavior: 'smooth'
      });
      window.history.replaceState({}, document.title, new URL(document.URL).pathname);
    }
  }

  let cotiza_content = document.querySelector(".cotiza-cortina .content");

  if (cotiza_content.style.maxHeight) {
    cotiza_content.style.maxHeight = null;
  } else {
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  }

  document.querySelector(".cotiza-tela-suboption .title-select-h4").textContent = "Selecciona Persiana";

  hideCotizaFormParts();

  loadCortinas();

  setCortinaTipo(input_cortina_tipos[0].value);
  setFormCotizadoCortinaTipo(input_cortina_tipos[0]);
  setAncho(`${input_ancho.value} cm`);
  setFormCotizadoAncho(input_ancho.value);
  setAlto(`${input_alto.value} cm`);
  setFormCotizadoAlto(input_alto.value);
  setTelaTipo(input_tela_tipos[0].value);
  setFormCotizadoTelaTipo(input_tela_tipos[0]);
  setTelaSuboption(input_tela_suboptions[0].value);
  setFormCotizadoTelaSuboption(input_tela_suboptions[0]);
  setValue("posicionMando", input_mando_posiciones[0].value);
  setFormCotizadoPosicionMando(input_mando_posiciones[0]);
  setInstalacionTipo(input_instalacion_tipos[0].value);
  setFormCotizadoInstalacionTipo(input_instalacion_tipos[0]);
  setFormCotizadoInstalacionRegion(input_instalacion_region[6]);
  setFormCotizadoInstalacionComuna(input_instalacion_direccion[47]);
  setFormCotizadoNombre(input_nombre.value);
  setFormCotizadoMensaje(input_mensaje.value);

  checkFormCotizacion();
  setForm();
  setHiddenFormProductos();
  triggerCheckMadera();
}

function hideCotizaFormParts() {
  if (document.querySelector(".val-accionamiento-tipo") !== null) {
    document.querySelector(".val-accionamiento-tipo").parentNode.classList.add("not-show");
  }
  if (document.querySelector(".val-caida-sentido") !== null) {
    document.querySelector(".val-caida-sentido").parentNode.classList.add("not-show");
  }
  if (document.querySelector(".val-color-accesorio") !== null) {
    document.querySelector(".val-color-accesorio").parentNode.classList.add("not-show");
  }
  if (document.querySelector(".val-confeccion-tipo") !== null) {
    document.querySelector(".val-confeccion-tipo").parentNode.classList.add("not-show");
  }
  if (document.querySelector(".val-tipo-cortina") !== null) {
    document.querySelector(".val-tipo-cortina").parentNode.classList.add("not-show");
  }
  if (document.querySelector(".val-cantidad-pano") !== null) {
    document.querySelector(".val-cantidad-pano").parentNode.classList.add("not-show");
  }
  if (document.querySelector(".val-instalacion") !== null) {
    document.querySelector(".val-instalacion").parentNode.classList.add("not-show");
  }
}

function setHiddenFormProductos() {
  setHiddenFormProductoAnillo({"input": hidden_producto_anillo_madera});
  setHiddenFormProductoBarra({"input": hidden_producto_barra_madera});
  setHiddenFormProductoBase({"input": hidden_producto_base_madera});
  setHiddenFormProductoBorla({"input": hidden_producto_borla_madera});
  setHiddenFormProductoBoton({"input": hidden_producto_boton_madera});
  setHiddenFormProductoBotonEscalera({"input": hidden_producto_boton_escalera_madera});
  setHiddenFormProductoBracketCentral({"input": hidden_producto_bracket_central_madera});
  setHiddenFormProductoBracketLateral({"input": hidden_producto_bracket_lateral_madera});
  setHiddenFormProductoCabezal({"input": hidden_producto_cabezal_madera});
  setHiddenFormProductoCenefa({"input": hidden_producto_cenefa_madera});
  setHiddenFormProductoClip1({"input": hidden_producto_clip_1_madera});
  setHiddenFormProductoClip2({"input": hidden_producto_clip_2_madera});
  setHiddenFormProductoClipCenefa({"input": hidden_producto_clip_cenefa_madera});
  setHiddenFormProductoCuerda({"input": hidden_producto_cuerda_madera});
  setHiddenFormProductoFreno({"input": hidden_producto_freno_madera});
  setHiddenFormProductoLama({"input": hidden_producto_lama_madera[0]});
  setHiddenFormProductoMadera1({"input": hidden_producto_madera_1_madera});
  setHiddenFormProductoMadera2({"input": hidden_producto_madera_2_madera});
  setHiddenFormProductoPiola({"input": hidden_producto_piola_madera});
  setHiddenFormProductoRiel({"input": hidden_producto_riel_madera});
  setHiddenFormProductoRodillo({"input": hidden_producto_rodillo_madera});
  setHiddenFormProductoTapa({"input": hidden_producto_tapa_madera});
  setHiddenFormProductoVarilla({"input": hidden_producto_varilla_madera});
  setHiddenFormProductoInstalacion({"input": hidden_producto_instalacion_madera});
}

function setRegion() {
  if (region_select.value !== '1') {
    radio_message_container.classList.add("show");
    radio_container.classList.remove("show");
    address_container.classList.remove("show");
    input_instalacion_tipos[1].checked = true;
    input_instalacion_tipos[1].dispatchEvent(new Event('change'));
  } else {
    radio_message_container.classList.remove("show");
    radio_container.classList.add("show");
    address_container.classList.add("show");
    input_instalacion_tipos[0].checked = true;
    input_instalacion_tipos[0].dispatchEvent(new Event('change'));
  }
}

// Click Reset
function resetForm() {
  let cotiza_content = document.querySelector(".cotiza-cortina .content");
  if (cotiza_content.style.maxHeight) {
    cotiza_content.style.maxHeight = null;
  } else {
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  }

  setInputCortinaTipo(0);
  setInputAncho("40");
  setInputAlto("40");
  setInputTelaTipo(indexInParent(getCurrentRadioWrap()));
  setInputInstalacionCortina(0);
  setInputNombre("");
  setInputMensaje("");
  closeAllSubtitles();
  closeAllTitles();
  openTitle(document.querySelector(".title-select-h1[data-option-number='1']"));

  let top_element = document.querySelector(".cortina-type").getBoundingClientRect().top;
  let header_height = document.querySelector("#shopify-section-header header").offsetHeight;
  window.scrollBy({
    top: top_element - header_height,
    left: 0,
    behavior: 'smooth'
  });
}

function checkFormCotizacion() {
  setTelaHeight();

  // Bloques
  let cotiza_active_blocks = document.querySelectorAll(`.cotiza-cortina[data-cortina-${form_cotizado_cortina_tipo.value}="true"]`);
  if (cotiza_active_blocks.length > 0) {
    turnOnCotizaParentParentBlocks(cotiza_active_blocks);
  }

  // Tela Tipo
  turnOffAllTelaTipoBlocks(input_tela_tipos);
  turnOnStockTelaTipoBlocks(input_tela_tipos);
}

function turnOnStockTelaTipoBlocks(cotiza_tela_tipo_blocks) {
  let colores  = document.querySelectorAll(".tela-opcion-colores");
  let opciones = document.querySelectorAll(".tela-suboptions");

  cotiza_tela_tipo_blocks.forEach(cotiza_tela_tipo_block => {
    let tela = cotiza_tela_tipo_block.dataset.value;

    opciones.forEach(options => {
      let tipo = options.dataset.value;
      let length_products = 0;

      colores.forEach(colors => {
        let color = colors.dataset.value;

        options.parentNode.parentNode.parentNode.classList.remove("hide");
        length_products = document.querySelectorAll(`.tradicional-products .product-tela-tradicional-tradicional[data-product-tela='${tela}'][data-product-tipo='${tipo}'][data-product-color='${color}']`).length;

        if (length_products > 0) {
          options.parentNode.parentNode.parentNode.classList.remove("hide");
        }

        if (length_products > 0) {
          cotiza_tela_tipo_block.parentNode.classList.add("show");
        }
      });
    });
  });

  let eClick     = new Event('click');
  let eChange    = new Event('change');
  let radio_wrap = document.querySelectorAll(".radios .radio-wrap.show .tela-tipos");

  if (radio_wrap.length > 0) {
    radio_wrap[0].checked = true;
    radio_wrap[0].dispatchEvent(eClick);
    radio_wrap[0].dispatchEvent(eChange);
  }
}

function triggerCheckMadera() {
  let eClick     = new Event('click');
  let eChange    = new Event('change');
  let radio_wrap = document.querySelector("input[name='tela-tipos']:checked");

  if (radio_wrap !== null) {
    radio_wrap.checked = true;
    radio_wrap.dispatchEvent(eClick);
    radio_wrap.dispatchEvent(eChange);
  }
}

function turnOffAllTelaTipoBlocks(tela_tipo_blocks) {
  tela_tipo_blocks.forEach(tela_tipo_block => {
    tela_tipo_block.parentNode.classList.remove("show");
  });
}

function turnOnCotizaParentParentBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(cotiza_block => {
    cotiza_block.parentNode.parentNode.classList.add("show");
  });

  let theTitle = document.querySelector(".option.active .title-select-h1") ? document.querySelector(".option.active .title-select-h1") : document.querySelector(".option .title-select-h1");

  openTitle(theTitle);
}

function turnOffAllCotizaBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(cotiza_block => {
    cotiza_block.classList.remove("show");
  });
}

function checkCotizaSinStock(params) {
  return true;
}

function setForm() {
  let response = true;
  if (checkCotizaSinStock()) {
    calculateBracketCentral({"input": hidden_producto_bracket_central_madera});
    calculateBracketLateral({"input": hidden_producto_bracket_lateral_madera});
    calculateClipCenefa({"input": hidden_producto_clip_cenefa_madera});
    calculateMadera2({"input": hidden_producto_madera_2_madera});
    calculateTapa({"input": hidden_producto_tapa_madera});
    calculateBorla({"input": hidden_producto_borla_madera});
    calculateClip2({"input": hidden_producto_clip_2_madera});
    calculateBase({"input": hidden_producto_base_madera});
    calculateRodillo({"input": hidden_producto_rodillo_madera});
    calculatePiola({"input": hidden_producto_piola_madera});
    calculateLama({"input": getHiddenProductoLamaMadera()});
    calculateCabezal({"input": hidden_producto_cabezal_madera});
    calculateCuerda({"input": hidden_producto_cuerda_madera});
    calculateConfeccion({"input": hidden_producto_confeccion_madera});
    calculateBotonEscalera({"input": hidden_producto_boton_escalera_madera});
    calculateBoton({"input": hidden_producto_boton_madera});
    calculateMadera1({"input": hidden_producto_madera_1_madera});

    setHiddenFormProductoInstalacion({"value": form_cotizado_instalacion.value});
    calculateTotalWeight({"anillo": hidden_producto_anillo_madera, "barra": hidden_producto_barra_madera, "base": hidden_producto_base_madera, "borla": hidden_producto_borla_madera, "boton": hidden_producto_boton_madera, "boton_escalera": hidden_producto_boton_escalera_madera, "bracket_central": hidden_producto_bracket_central_madera, "bracket_lateral": hidden_producto_bracket_lateral_madera, "cabezal": hidden_producto_cabezal_madera, "cenefa": hidden_producto_cenefa_madera, "clip_1": hidden_producto_clip_1_madera, "clip_2": hidden_producto_clip_2_madera, "clip_cenefa": hidden_producto_clip_cenefa_madera, "cuerda": hidden_producto_cuerda_madera, "freno": hidden_producto_freno_madera, "lama": getHiddenProductoLamaMadera(), "madera_1": hidden_producto_madera_1_madera, "madera_2": hidden_producto_madera_2_madera, "piola": hidden_producto_piola_madera, "riel": hidden_producto_riel_madera, "rodillo": hidden_producto_rodillo_madera, "tapa": hidden_producto_tapa_madera, "varilla": hidden_producto_varilla_madera});

    calculaCotizacion();
  } else {
    response = false;
  }
  return response;
}


function updateHiddenFormProduct(targetElement, params) {
  const { input, value, grams } = params;

  // Asignar el valor directamente y luego ajustar si es necesario.
  targetElement.value = value || (input && input.value);

  if (input) {
    if ('productAvailable' in input.dataset) {
      targetElement.dataset.productAvailable = input.dataset.productAvailable;
    }

    if ('productQuantity' in input.dataset) {
      targetElement.dataset.productQuantity = input.dataset.productQuantity;
    }

    if ('productSku' in input.dataset) {
      targetElement.dataset.productSku = input.dataset.productSku;
    }

    if ('productTitle' in input.dataset) {
      targetElement.dataset.productTitle = input.dataset.productTitle;
    }

    if ('descripcionSoftland' in input.dataset) {
      targetElement.dataset.descripcionSoftland = input.dataset.descripcionSoftland;
    }

    if ('skuSoftland' in input.dataset) {
      targetElement.dataset.skuSoftland = input.dataset.skuSoftland;
    }

    if ('productWeight' in input.dataset) {
      targetElement.dataset.productWeight = input.dataset.productWeight;
    }

    if ('productWeightUnit' in input.dataset) {
      targetElement.dataset.productWeightUnit = input.dataset.productWeightUnit;
    }

    if (value === 0) {
      targetElement.value = 0;
    }
  }

  if (grams) {
    targetElement.dataset.grams = grams;
  }
}

// Cotizador Input
function setInputCortinaTipo(value) {
  input_cortina_tipos[value].checked = true;
  input_cortina_tipos[value].dispatchEvent(new Event('change'));
}

function setInputAncho(value) {
  input_ancho.value = value;
  input_ancho.dispatchEvent(new Event('change'));
}

function setInputAlto(value) {
  input_alto.value = value;
  input_alto.dispatchEvent(new Event('change'));
}

function setInputTelaTipo(value) {
  input_tela_tipos[value].checked = true;
  input_tela_tipos[value].dispatchEvent(new Event('change'));
}

function setInputAccionamientoTipo(value) {
  input_accionamiento_tipos[value].checked = true;
  input_accionamiento_tipos[value].dispatchEvent(new Event('change'));
}

function setInputCaidaSentido(value) {
  input_caida_sentidos[value].checked = true;
  input_caida_sentidos[value].dispatchEvent(new Event('change'));
}

function setInputColorAccesorio(value) {
  input_color_accesorios[value].checked = true;
  input_color_accesorios[value].dispatchEvent(new Event('change'));
}

function setInputPosicionMando(value) {
  input_mando_posiciones[value].checked = true;
  input_mando_posiciones[value].dispatchEvent(new Event('change'));
}

function setInputInstalacionCortina(value) {
  input_cortina_instalaciones[value].checked = true;
  input_cortina_instalaciones[value].dispatchEvent(new Event('change'));
}

function setInputNombre(value) {
  input_nombre.value = value;
  input_nombre.dispatchEvent(new Event('change'));
}

function setInputMensaje(value) {
  input_mensaje.value = value;
  input_mensaje.dispatchEvent(new Event('change'));
}

function getCotizadorProductDataset(product) {
  return product && product.dataset ? product.dataset : {};
}

function getMaderaLamaProductsFromStore() {
  if (typeof findCotizadorProductGroup === "function") {
    const groupedProducts = findCotizadorProductGroup("maderaProducts", {
      productKey: "madera",
      containerClass: "madera-products",
      className: "product-lama-madera"
    });
    if (groupedProducts.length > 0) return groupedProducts;
  }

  if (typeof findCotizadorProducts !== "function") return [];

  return findCotizadorProducts({
    productKey: "madera",
    containerClass: "madera-products",
    className: "product-lama-madera"
  });
}

function findMaderaLamaProductsFromStore(filters) {
  return getMaderaLamaProductsFromStore().filter(product => {
    const dataset = getCotizadorProductDataset(product);
    return Object.keys(filters).every(key => !filters[key] || dataset[key] === filters[key]);
  });
}

function generateHTMLTemplate(input, index, telaType) {
  const dataset = getCotizadorProductDataset(input);

  return `
    <input type="radio" class="radio tela-opcion-colores tela-opcion-color-${telaType}" id="tela_opcion_colores_${index}" name="tela-opcion-colores" data-value="${dataset.productColor}" data-sku-softland="${dataset.skuSoftland}" data-sku="${dataset.productSku}" value="${dataset.productColorFull}">
    <label class="label-colores label-colores-${telaType}" for="tela_opcion_colores_${index}">
      <img src="${dataset.productImageTiny}" alt="${dataset.productTitle}" srcset="${dataset.productImageTiny}" width="29" height="29" loading="lazy">
      <span class="span-color">${dataset.productColorFull}</span>
    </label>`;
}

function handleizeCotizadorValue(value) {
  return (value || "")
    .toString()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getCotizadorBootstrapPayload() {
  return window.cotizadorBootstrapState && window.cotizadorBootstrapState.data ? window.cotizadorBootstrapState.data : null;
}

function getCotizadorBootstrapStockBySku(bootstrap) {
  const stock = bootstrap && Array.isArray(bootstrap.stock) ? bootstrap.stock : [];
  return new Map(stock.map(item => [(item.sku || "").toString().trim().toUpperCase(), item]));
}

function setBootstrapDatasetValue(input, key, value, transform) {
  if (value === undefined || value === null || value === "") return;
  input.dataset[key] = transform ? transform(value) : value.toString();
}

function applyBootstrapImagesToMaderaInput(input, images) {
  const primary = images && images.primary ? images.primary : null;
  const secondary = images && images.secondary ? images.secondary : primary;
  const fallback = input.dataset.productImageTiny || "";

  setBootstrapDatasetValue(input, "productImage", secondary && secondary.previewUrl ? secondary.previewUrl : fallback);
  setBootstrapDatasetValue(input, "productImageZoom", secondary && secondary.zoomUrl ? secondary.zoomUrl : fallback);
  setBootstrapDatasetValue(input, "productImageExtra", primary && primary.previewUrl ? primary.previewUrl : fallback);
  setBootstrapDatasetValue(input, "productImageExtraZoom", primary && primary.zoomUrl ? primary.zoomUrl : fallback);
  setBootstrapDatasetValue(input, "productImageTiny", primary && primary.tinyUrl ? primary.tinyUrl : fallback);
}

function upsertBootstrapLamaMaderaProduct(item, stockBySku) {
  const sku = (item.sku || "").toString().trim();
  const tipo = handleizeCotizadorValue(item.subtipo || item.categoria);
  const color = handleizeCotizadorValue(item.color);
  const container = document.querySelector(".madera-products");

  if (!sku || !color || !container) return null;

  let input = container.querySelector(`.product-lama-madera[data-product-sku='${sku}'][data-product-color='${color}']`);
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `producto-bootstrap-product-lama-madera-${sku}`;
    input.className = "product-lama-madera";
    input.dataset.bootstrapCatalog = "true";
    container.appendChild(input);
  }

  const stock = stockBySku.get(sku.toUpperCase());
  const price = stock && Number.isFinite(Number(stock.price)) ? Number(stock.price) : Number(item.price || 0);
  const quantity = stock && Number.isFinite(Number(stock.quantity)) ? Number(stock.quantity) : Number(item.inventoryQuantity || 0);

  input.value = `${Math.round(price)}`;
  setBootstrapDatasetValue(input, "productSku", sku);
  setBootstrapDatasetValue(input, "productTitle", item.name);
  setBootstrapDatasetValue(input, "productTela", "madera");
  setBootstrapDatasetValue(input, "productTipo", tipo);
  setBootstrapDatasetValue(input, "productColor", color);
  setBootstrapDatasetValue(input, "productColorFull", item.colorFull || item.color);
  setBootstrapDatasetValue(input, "skuSoftland", item.skuSoftland || sku);
  setBootstrapDatasetValue(input, "descripcionSoftland", (stock && stock.description) || item.descripcionSoftland || item.name);
  setBootstrapDatasetValue(input, "productWeight", item.weight || 0);
  setBootstrapDatasetValue(input, "productWeightUnit", item.weightUnit || "g");
  setBootstrapDatasetValue(input, "productQuantity", quantity);
  setBootstrapDatasetValue(input, "productAvailable", quantity > 0 ? "true" : "false");
  applyBootstrapImagesToMaderaInput(input, item.images);

  return input;
}

function hydrateBootstrapLamaMaderaProducts() {
  const bootstrap = getCotizadorBootstrapPayload();
  const catalog = bootstrap && Array.isArray(bootstrap.catalog) ? bootstrap.catalog : [];
  if (catalog.length === 0) return [];

  const stockBySku = getCotizadorBootstrapStockBySku(bootstrap);
  return catalog
    .map(item => upsertBootstrapLamaMaderaProduct(item, stockBySku))
    .filter(Boolean);
}

function getBootstrapSoftlandSku(softland) {
  if (!softland) return "";
  return (softland.codRapido || softland.codBarra || "").toString().trim();
}

function handleizeCotizadorComponentKey(value) {
  return (value || "")
    .toString()
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function buildMaderaComponentClassName(key) {
  const componentKey = handleizeCotizadorComponentKey(key);
  if (componentKey === "instalacion") return "tradicional-instalacion-tradicional";
  return `product-${componentKey}-madera`;
}

function getBootstrapComponentStock(item, stockBySku) {
  const sku = (item.sku || "").toString().trim().toUpperCase();
  return sku ? stockBySku.get(sku) : null;
}

function upsertBootstrapMaderaComponent(item, stockBySku) {
  const key = (item.key || "").toString().trim();
  const sku = (item.sku || "").toString().trim();
  const container = document.querySelector(".madera-products");
  if (!container || !key || !sku || key.toLowerCase() === "lama") return null;

  const className = buildMaderaComponentClassName(key);
  let input = container.querySelector(`.${className}[data-product-sku='${sku}']`) || container.querySelector(`.${className}`);
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `producto-bootstrap-${className}-${sku}`;
    input.className = className;
    input.dataset.bootstrapComponent = "true";
    container.appendChild(input);
  }

  const stock = getBootstrapComponentStock(item, stockBySku);
  const price = Number.isFinite(Number(item.price)) ? Number(item.price) : (stock && Number.isFinite(Number(stock.price)) ? Number(stock.price) : 0);
  const quantity = Number.isFinite(Number(item.quantity)) ? Number(item.quantity) : (stock && Number.isFinite(Number(stock.quantity)) ? Number(stock.quantity) : Number(input.dataset.productQuantity || 0));

  input.value = `${Math.round(price)}`;
  setBootstrapDatasetValue(input, "productSku", sku);
  setBootstrapDatasetValue(input, "productTitle", item.name);
  setBootstrapDatasetValue(input, "skuSoftland", item.skuSoftland || getBootstrapSoftlandSku(item.softland) || sku);
  setBootstrapDatasetValue(input, "descripcionSoftland", item.descripcionSoftland || (stock && stock.description) || item.name);
  setBootstrapDatasetValue(input, "productQuantity", quantity);
  setBootstrapDatasetValue(input, "productAvailable", item.available === true || quantity > 0 ? "true" : (input.dataset.productAvailable || "false"));
  setBootstrapDatasetValue(input, "productWeight", Number.isFinite(Number(item.weight)) ? item.weight : (input.dataset.productWeight || 0));
  setBootstrapDatasetValue(input, "productWeightUnit", item.weightUnit || input.dataset.productWeightUnit || "g");
  setBootstrapDatasetValue(input, "compareAtPrice", item.compareAtPrice || (stock && stock.compareAtPrice));

  return input;
}

function hydrateBootstrapMaderaComponents() {
  const bootstrap = getCotizadorBootstrapPayload();
  const componentes = bootstrap && Array.isArray(bootstrap.componentes) ? bootstrap.componentes : [];
  if (componentes.length === 0) return [];

  const stockBySku = getCotizadorBootstrapStockBySku(bootstrap);
  return componentes
    .filter(item => (item.productKey || "").toString().trim().toLowerCase() === "madera")
    .map(item => upsertBootstrapMaderaComponent(item, stockBySku))
    .filter(Boolean);
}

function refreshHiddenProductoMaderaRefs() {
  hidden_producto_anillo_madera               = document.querySelector(".madera-products .product-anillo-madera");
  hidden_producto_barra_madera                = document.querySelector(".madera-products .product-barra-madera");
  hidden_producto_base_madera                 = document.querySelector(".madera-products .product-base-madera");
  hidden_producto_borla_madera                = document.querySelector(".madera-products .product-borla-madera");
  hidden_producto_boton_madera                = document.querySelector(".madera-products .product-boton-madera");
  hidden_producto_boton_escalera_madera       = document.querySelector(".madera-products .product-boton-escalera-madera");
  hidden_producto_bracket_central_madera      = document.querySelector(".madera-products .product-bracket-central-madera");
  hidden_producto_bracket_lateral_madera      = document.querySelector(".madera-products .product-bracket-lateral-madera");
  hidden_producto_cabezal_madera              = document.querySelector(".madera-products .product-cabezal-madera");
  hidden_producto_cenefa_madera               = document.querySelector(".madera-products .product-cenefa-madera");
  hidden_producto_clip_1_madera               = document.querySelector(".madera-products .product-clip-1-madera");
  hidden_producto_clip_2_madera               = document.querySelector(".madera-products .product-clip-2-madera");
  hidden_producto_clip_cenefa_madera          = document.querySelector(".madera-products .product-clip-cenefa-madera");
  hidden_producto_cuerda_madera               = document.querySelector(".madera-products .product-cuerda-madera");
  hidden_producto_freno_madera                = document.querySelector(".madera-products .product-freno-madera");
  hidden_producto_lama_madera                 = document.querySelectorAll(".madera-products .product-lama-madera");
  hidden_producto_madera_1_madera             = document.querySelector(".madera-products .product-madera-1-madera");
  hidden_producto_madera_2_madera             = document.querySelector(".madera-products .product-madera-2-madera");
  hidden_producto_piola_madera                = document.querySelector(".madera-products .product-piola-madera");
  hidden_producto_riel_madera                 = document.querySelector(".madera-products .product-riel-madera");
  hidden_producto_rodillo_madera              = document.querySelector(".madera-products .product-rodillo-madera");
  hidden_producto_tapa_madera                 = document.querySelector(".madera-products .product-tapa-madera");
  hidden_producto_varilla_madera              = document.querySelector(".madera-products .product-varilla-madera");
  hidden_producto_confeccion_madera           = document.querySelector(".madera-products .product-confeccion-madera") || document.querySelector(".product-confeccion-madera");
  hidden_producto_instalacion_madera          = document.querySelector(".madera-products .tradicional-instalacion-tradicional") || document.querySelector(".tradicional-instalacion-tradicional");
}

function getUniqueCotizadorProducts(products) {
  const seen = new Set();

  return products.filter(product => {
    const dataset = getCotizadorProductDataset(product);
    const productTela = dataset.productTela || product.productKey || "";
    const key = [
      productTela,
      dataset.productColor || ""
    ].join("|");

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function isMaderaLamaProduct(input) {
  const dataset = getCotizadorProductDataset(input);
  return dataset.productTela === "madera"
    || input.productKey === "madera"
    || input.className === "product-lama-madera"
    || (input.classList && input.classList.contains("product-lama-madera"));
}

// Load Cortinas
function loadCortinas() {
  let index = 1;
  let color_telas = document.querySelectorAll(".cotiza-tela-color");
  const bootstrapLamaProducts = hydrateBootstrapLamaMaderaProducts();
  refreshHiddenProductoMaderaRefs();
  const storeLamaProducts = getMaderaLamaProductsFromStore();
  const allLamaProducts = getUniqueCotizadorProducts(bootstrapLamaProducts.concat(storeLamaProducts));
  const lamaInputs = allLamaProducts.length > 0 ? allLamaProducts : Array.from(hidden_producto_lama_madera);

  if (color_telas.length === 0) return;
  color_telas.forEach(color_tela => { color_tela.innerHTML = ""; });
  color_telas[0].parentNode.classList.add("show");

  lamaInputs.forEach(input => {
    if (isMaderaLamaProduct(input)) {
      color_telas[0].insertAdjacentHTML('beforeend', generateHTMLTemplate(input, index, "madera"));
      index++;
    }
  });

  const labelColoresRadios = document.querySelectorAll(".label-colores");
  addEventListenerToCollection(labelColoresRadios, "click", activeLabelRadio);

  const telaOpcionColoresInputs = document.querySelectorAll("input[name='tela-opcion-colores']");
  addEventListenerToCollection(telaOpcionColoresInputs, "change", setCotizacion, "telaOptionColor");
}
// Formulario Input
const elementsMap = {
  "cortinaTipo": cotizacion_cortina_tipo,
  "ancho": cotizacion_ancho,
  "alto": cotizacion_alto,
  "telaTipo": cotizacion_tela_tipo,
  "telaSuboption": cotizacion_tela_suboption,
  "cantidadPano": cotizacion_cantidad_pano,
  "tipoCortina": cotizacion_tipo_cortina,
  "telaOptionColor": cotizacion_tela_suboption,
  "accionamientoTipo": cotizacion_accionamiento_tipo,
  "caidaSentido": cotizacion_caida_sentido,
  "colorAccesorio": cotizacion_color_accesorio,
  "posicionMando": cotizacion_posicion_mando,
  "instalacionCortina": cotizacion_instalacion_cortina,
  "instalacionTipo": cotizacion_instalacion
};

function setValue(field, value) {
  const element = elementsMap[field];

  if (element) {
    if (field === "telaTipo") {
      const tela_option = document.querySelector("input[name='tela-tipos']:checked").dataset.value;
      const tela_suboption = document.querySelector("input[name='tela-suboptions']:checked").value;

      if (tela_option == "screen") {
        element.innerHTML = `${value} - ${tela_suboption}`;
      } else {
        element.innerHTML = value;
      }
    } else if (field === "accionamientoTipo") {
      if (value === "Motorizado" && input_control_motor.checked) {
        element.innerHTML = value + " + Control Remoto";
        form_cotizado_accionamiento_tipo.dataset.value = value + " + Control Remoto";
      } else {
        element.innerHTML = value;
        form_cotizado_accionamiento_tipo.dataset.value = value;
      }
    } else {
      element.innerHTML = value;
    }
  } else {
    console.warn(`Element for field ${field} not found.`);
  }
}

// Formulario Input
function setCortinaTipo(value) {
  cotizacion_cortina_tipo.innerHTML = value;
}

function setAncho(value) {
  cotizacion_ancho.innerHTML = value;
}

function setAlto(value) {
  cotizacion_alto.innerHTML = value;
}

function setTelaTipo(value) {
  cotizacion_tela_tipo.innerHTML = value;
}

function setTelaSuboption(value) {
  cotizacion_tela_suboption.innerHTML = value;
}

function setCantidadPano(value) {
  cotizacion_cantidad_pano.innerHTML = value;
}

function setTipoCortina(value) {
  cotizacion_tipo_cortina.innerHTML = value;
}

function setTelaOptionColor(value) {
  cotizacion_tela_suboption.innerHTML = value;
}

function setAccionamientoTipo(value) {
  cotizacion_accionamiento_tipo.innerHTML = value;
}

function setCaidaSentido(value) {
  cotizacion_caida_sentido.innerHTML = value;
}

function setColorAccesorio(value) {
  cotizacion_color_accesorio.innerHTML = value;
}

function setPosicionMando(value) {
  cotizacion_posicion_mando.innerHTML = value;
}

function setInstalacionCortina(value) {
  cotizacion_instalacion_cortina.innerHTML = value;
}

function setInstalacionTipo(value) {
  cotizacion_instalacion_cortina.innerHTML = value;
  cotizacion_instalacion.innerHTML = value;
}

function setNombre(value) {
  form_nombre.value = value;
}

function setMensaje(value) {
  form_mensaje.value = value;
}

function setSkuSoftland() {
  const sku_softland = document.querySelector("input[name='tela-opcion-colores']:checked");

  if (sku_softland) {
    if (sku_softland.dataset.skuSoftland !== 'undefined') {
      form_cotizado_homologado_venta.value = sku_softland.dataset.skuSoftland;

      const radio = sku_softland.parentElement.parentElement
        .firstElementChild
        .getElementsByClassName("tela-suboptions")[0]; // accede al primero si hay más de uno

      if (radio) {
        radio.checked = true;
        // Crea un nuevo evento de cambio
        let event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });

        // Despacha el evento de cambio
        radio.dispatchEvent(event);
      }
    } else {
      form_cotizado_homologado_venta.value = '';
    }
  } else {
    form_cotizado_homologado_venta.value = '';
  }
}

// Formulario Cotizacion
function setCotizacionCortinaTipo(event) {
  setCortinaTipo(`${this.value}`);
  setFormCotizadoCortinaTipo(this);
  checkFormCotizacion();
  setSkuSoftland();
  setForm();
}

function setCotizacionAncho(event) {
  if (parseInt(this.value) <= parseInt(this.attributes.max.value) && parseInt(this.value) >= parseInt(this.attributes.min.value)) {
    setAncho(`${this.value} cm`);
    setFormCotizadoAncho(this.value);
    setForm();
  } else {
    if (parseInt(this.value) > parseInt(this.attributes.max.value)) {
      this.value = this.attributes.max.value;
    } else if (parseInt(this.value) < parseInt(this.attributes.min.value)) {
      this.value = this.attributes.min.value;
    }
  }
}

function setCotizacionAlto(event) {
  if (parseInt(this.value) <= parseInt(this.attributes.max.value) && parseInt(this.value) >= parseInt(this.attributes.min.value)) {
    setAlto(`${this.value} cm`);
    setFormCotizadoAlto(this.value);
    setForm();
  } else {
    if (parseInt(this.value) > parseInt(this.attributes.max.value)) {
      this.value = this.attributes.max.value;
    } else if (parseInt(this.value) < parseInt(this.attributes.min.value)) {
      this.value = this.attributes.min.value;
    }
  }
}

function setCotizacionTelaTipo(event) {
  if (this.dataset.optionScreen === "true" || document.querySelector(".cotiza51").dataset.cotizador == "madera") {
    document.querySelector(".cotiza-tela-suboption").classList.remove("show");
    document.querySelector(".cotiza-tela-suboption").firstElementChild.innerHTML = `Selecciona Color`;
    document.querySelector(".cotiza-tela-suboption").classList.add("no-screen");
    document.querySelector(".cotiza-tela-suboption").classList.remove("no-duo");
  }
  setTelaColors({"tipo": getCurrentTipo(), "tela": getCurrentTela()});
  setTelaTipo(this.value);
  setFormCotizadoTelaTipo(this);
  setForm();
  setTelaHeight();
}

// Elemento para obtener el tipo de cortina seleccionada
function getCurrentTipo() {
  return (document.querySelector("input[name='cortina-tipos']:checked") ? document.querySelector("input[name='cortina-tipos']:checked").dataset.value : null);
}

// Elemento para obtener el tipo de tela seleccionada
function getCurrentTela() {
  return (document.querySelector("input[name='tela-tipos']:checked") ? document.querySelector("input[name='tela-tipos']:checked").dataset.value : null);
}

// Elemento para obtener el tipo de tela seleccionada
function getCurrentTelaValue() {
  return (document.querySelector("input[name='tela-tipos']:checked") ? document.querySelector("input[name='tela-tipos']:checked").value : null);
}

// Elemento para obtener el tipo de subtela seleccionada en caso de ser una tela screen
function getCurrentSubtela() {
  return (document.querySelector("input[name='tela-suboptions']:checked") ? document.querySelector("input[name='tela-suboptions']:checked").dataset.value : null);
}

// Elemento para obtener la primera tela visible de la lista
function getCurrentRadioWrap() {
  return document.querySelector(".radios .show");
}

function setTelaColors(params) {
  let tela_tipo   = params.tipo;
  let tela_option = params.tela;
  turnOffAllColors();
  document.querySelectorAll("input[name='tela-opcion-colores']").forEach(input_tela_opcion_color => {
    let input_tela = null;
    if (tela_tipo === "madera") {
      const suboption = input_tela_opcion_color.closest(".suboptions");
      const productTipo = suboption ? suboption.dataset.productTipo : "";
      input_tela = findMaderaLamaProductsFromStore({
        productTela: tela_option,
        productTipo,
        productColor: input_tela_opcion_color.dataset.value
      });
      if (input_tela.length === 0) {
        input_tela = findMaderaLamaProductsFromStore({
          productTela: tela_option,
          productColor: input_tela_opcion_color.dataset.value
        });
      }
      if (input_tela.length === 0) {
        input_tela = document.querySelectorAll(`.madera-products .product-lama-madera[data-product-tela='${tela_option}'][data-product-tipo='${productTipo}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);
      }
      if (input_tela.length === 0) {
        input_tela = document.querySelectorAll(`.madera-products .product-lama-madera[data-product-tela='${tela_option}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);
      }
      turnOnActiveColors({"input": input_tela, "input_tela_opcion_color": input_tela_opcion_color});
    }
  });

  let eClick = new Event('click');
  let eChange = new Event('change');
  let radio_wrap = document.querySelectorAll(".option2 .suboptions:not(.hide) .radio-wrap");

  if (radio_wrap.length === 0) {
    radio_wrap = document.querySelectorAll(".option2 .suboptions .radio-wrap");
  }

  if (radio_wrap.length > 0) {
    radio_wrap[0].firstElementChild.checked = true;
    radio_wrap[0].firstElementChild.dispatchEvent(eClick);
    radio_wrap[0].firstElementChild.dispatchEvent(eChange);
  }
}

function turnOffAllColors() {
  document.querySelectorAll("input[name='tela-opcion-colores']").forEach(input_tela_opcion_color => {
    input_tela_opcion_color.classList.add("hide");
    input_tela_opcion_color.nextElementSibling.classList.add("hide");
  });
}

function turnOnActiveColors(params) {
  let input_tela              = params["input"];
  let input_tela_opcion_color = params["input_tela_opcion_color"];
  if (input_tela.length > 0) {
    input_tela_opcion_color.classList.remove("hide");
    input_tela_opcion_color.nextElementSibling.classList.remove("hide");
  }
}

function toggleColor(params) {
  let input_tela              = params["input"];
  let input_tela_opcion_color = params["input_tela_opcion_color"];
  if (input_tela.length == 0) {
    input_tela_opcion_color.classList.add("hide");
    input_tela_opcion_color.nextElementSibling.classList.add("hide");
  } else {
    input_tela_opcion_color.classList.remove("hide");
    input_tela_opcion_color.nextElementSibling.classList.remove("hide");
  }
}

function setTelaHeight() {
  document.querySelector(`.tela`).style.maxHeight = document.querySelector(`.tela`).scrollHeight + 'px';
  document.querySelector(`.cotiza-tela-tipo .content`).style.maxHeight = document.querySelector(`.cotiza-tela-tipo .content`).scrollHeight + 'px';
}

function setCotizacion(event, configType) {
  switch (configType) {
    case "telaTipo":
      handleTelaTipo(this);
      break;
    case "telaSuboption":
      const tipo_tela = getCurrentTelaValue();
      setValue("telaTipo", tipo_tela);
      setFormCotizadoTelaSuboption(this);
      break;
    case "cortinaTipo":
      setValue("cortinaTipo", `${this.value}`);
      setFormCotizadoCortinaTipo(this);
      checkFormCotizacion();
      break;
    case "motorControl":
      checkFormCotizacion();
      break;
    case "confeccionTipo":
      setValue("confeccionTipo", `${this.value}`);
      setFormCotizadoConfeccionTipo(this);
      break;
    default:
      setValue(configType, this.value);
      setSkuSoftland();
      const setFormFunction = formFunctions[configType];
      if (setFormFunction) setFormFunction(this);
  }

  if (!["instalacionRegion", "instalacionComuna", "nombre", "mensaje"].includes(configType)) {
      setForm();
  }
}

function setCotizacionTelaSuboption(event) {
  let tipo_tela = getCurrentTelaValue();
  setTelaTipo(tipo_tela);
  setFormCotizadoTelaSuboption(this);
  setForm();
}

function setCotizacionTelaOptionColor(event) {
  setTelaOptionColor(`${this.value}`);
  setFormCotizadoTelaOpcionColor(this);
  setSkuSoftland()
  setForm();
}

function setCotizacionTipoCortina(event) {
  setTipoCortina(`${this.value}`);
  setFormCotizadoTipoCortina(this);
  setForm();
}

function setCotizacionInstalacionCortina(event) {
  setInstalacionCortina(`${this.value}`);
  setFormCotizadoInstalacionCortina(this);
  setForm();
}

function setCotizacionInstalacionTipo(event) {
  setInstalacionTipo(`${this.value}`);
  setFormCotizadoInstalacionTipo(this);
  setForm();
}

const formFunctions = {
  "telaOptionColor": setFormCotizadoTelaOpcionColor,
  "colorAccesorio": setFormCotizadoColorAccesorio,
  "posicionMando": setFormCotizadoPosicionMando,
  "instalacionCortina": setFormCotizadoInstalacionCortina,
  "instalacionTipo": setFormCotizadoInstalacionTipo
};

function setCotizacionInstalacionRegion(event) {
  setFormCotizadoInstalacionRegion(this.value);
}

function setCotizacionInstalacionComuna(event) {
  setFormCotizadoInstalacionComuna(this.value);
}

function setCotizacionInstalacionDireccion(event) {
  setFormCotizadoInstalacionDireccion(this.value);
}

function setCotizacionNombre(event) {
  setFormCotizadoNombre(this.value);
}

function setCotizacionMensaje(event) {
  setFormCotizadoMensaje(this.value);
}

// Formulario Cotizado
function setFormCotizadoCortinaTipo(input) {
  form_cotizado_cortina_tipo.value         = input.dataset.value;
  form_cotizado_cortina_tipo.dataset.value = input.value;
  input_cortina_tipos.forEach(input_cortina_tipo => {
    input_cortina_tipo.parentNode.parentNode.classList.remove("active");
  });
  input.parentNode.parentNode.classList.add("active");
}

function setFormCotizadoAncho(value) {
  form_cotizado_ancho.value = value;
}

function setFormCotizadoAlto(value) {
  form_cotizado_alto.value = value;
}

function setFormCotizadoTelaTipo(input) {
  form_cotizado_tela_tipo.value         = input.dataset.value;
  form_cotizado_tela_tipo.dataset.value = input.value;
}

function setFormCotizadoTelaSuboption(input) {
  form_cotizado_tela_suboption.value         = input.dataset.value;
  form_cotizado_tela_suboption.dataset.value = input.value;
}

function setFormCotizadoTelaOpcionColor(input) {
  form_cotizado_tela_opcion_color.value         = input.dataset.value;
  form_cotizado_tela_opcion_color.dataset.value = input.value;
}

function setFormCotizadoTipoCortina(input) {
  form_cotizado_tipo_cortina.value         = input.dataset.value;
  form_cotizado_tipo_cortina.dataset.value = input.value;
}

function setFormCotizadoColorAccesorio(input) {
  form_cotizado_color_accesorio.value         = input.dataset.value;
  form_cotizado_color_accesorio.dataset.value = input.value;
}

function setFormCotizadoPosicionMando(input) {
  form_cotizado_mando_posicion.value         = input.dataset.value;
  form_cotizado_mando_posicion.dataset.value = input.value;
}

function setFormCotizadoInstalacionCortina(input) {
  form_cotizado_cortina_instalacion.value         = input.dataset.value;
  form_cotizado_cortina_instalacion.dataset.value = input.value;
}

function setFormCotizadoInstalacionTipo(input) {
  form_cotizado_instalacion.value         = input.dataset.value;
  form_cotizado_instalacion.dataset.value = input.value;
}

function setFormCotizadoInstalacionRegion(value) {
  form_cotizado_instalacion_region.value = input_instalacion_region.options[input_instalacion_region.selectedIndex].text;
}

function setFormCotizadoInstalacionComuna(value) {
  form_cotizado_instalacion_comuna.value = input_instalacion_comuna.options[input_instalacion_comuna.selectedIndex].text;
}

function setFormCotizadoInstalacionDireccion(value) {
  form_cotizado_instalacion_direccion.value = value;
}

function setFormCotizadoNombre(value) {
  form_cotizado_nombre.value = value;
}

function setFormCotizadoMensaje(value) {
  form_cotizado_mensaje.value = value;
}

// Hidden Form Productos
function setHiddenFormProducto(object, params) {
  let input = params["input"];
  let value = params["value"];
  object.value = value;

  if (!input) return;

  if ('productAvailable' in input.dataset) object.dataset.productAvailable = input.dataset.productAvailable;
  if ('productQuantity' in input.dataset) object.dataset.productQuantity = input.dataset.productQuantity;
  if ('productSku' in input.dataset) object.dataset.productSku = input.dataset.productSku;
  if ('productTitle' in input.dataset) object.dataset.productTitle = input.dataset.productTitle;
  if ('descripcionSoftland' in input.dataset) object.dataset.descripcionSoftland = input.dataset.descripcionSoftland;
  if ('skuSoftland' in input.dataset) object.dataset.skuSoftland = input.dataset.skuSoftland;
  if ('productWeight' in input.dataset) object.dataset.productWeight = input.dataset.productWeight;
  if ('productWeightUnit' in input.dataset) object.dataset.productWeightUnit = input.dataset.productWeightUnit;
}

function setHiddenFormProductoPesoEnvio(params) {
  let value = params["value"];
  let grams = params["grams"];
  hidden_form_producto_peso_envio_madera.value = value;
  hidden_form_producto_peso_envio_madera.dataset.grams = grams;
}

function setHiddenFormProductoConfeccion(params) {
  let value = params["value"];
  hidden_form_producto_confeccion_madera.value = value;
}

// Hidden Form Productos Madera
function setHiddenFormProductoAnillo(params) {
  updateHiddenFormProduct(hidden_form_producto_anillo_madera, params);
}

function setHiddenFormProductoBarra(params) {
  updateHiddenFormProduct(hidden_form_producto_barra_madera, params);
}

function setHiddenFormProductoBase(params) {
  updateHiddenFormProduct(hidden_form_producto_base_madera, params);
}

function setHiddenFormProductoBorla(params) {
  updateHiddenFormProduct(hidden_form_producto_borla_madera, params);
}

function setHiddenFormProductoBoton(params) {
  updateHiddenFormProduct(hidden_form_producto_boton_madera, params);
}

function setHiddenFormProductoBotonEscalera(params) {
  updateHiddenFormProduct(hidden_form_producto_boton_escalera_madera, params);
}

function setHiddenFormProductoBracketCentral(params) {
  updateHiddenFormProduct(hidden_form_producto_bracket_central_madera, params);
}

function setHiddenFormProductoBracketLateral(params) {
  updateHiddenFormProduct(hidden_form_producto_bracket_lateral_madera, params);
}

function setHiddenFormProductoCabezal(params) {
  updateHiddenFormProduct(hidden_form_producto_cabezal_madera, params);
}

function setHiddenFormProductoCenefa(params) {
  updateHiddenFormProduct(hidden_form_producto_cenefa_madera, params);
}

function setHiddenFormProductoClip1(params) {
  updateHiddenFormProduct(hidden_form_producto_clip_1_madera, params);
}

function setHiddenFormProductoClip2(params) {
  updateHiddenFormProduct(hidden_form_producto_clip_2_madera, params);
}

function setHiddenFormProductoClipCenefa(params) {
  updateHiddenFormProduct(hidden_form_producto_clip_cenefa_madera, params);
}

function setHiddenFormProductoCuerda(params) {
  updateHiddenFormProduct(hidden_form_producto_cuerda_madera, params);
}

function setHiddenFormProductoFreno(params) {
  updateHiddenFormProduct(hidden_form_producto_freno_madera, params);
}

function setHiddenFormProductoLama(params) {
  updateHiddenFormProduct(hidden_form_producto_lama_madera, params);
}

function setHiddenFormProductoMadera1(params) {
  updateHiddenFormProduct(hidden_form_producto_madera_1_madera, params);
}

function setHiddenFormProductoMadera2(params) {
  updateHiddenFormProduct(hidden_form_producto_madera_2_madera, params);
}

function setHiddenFormProductoPiola(params) {
  updateHiddenFormProduct(hidden_form_producto_piola_madera, params);
}

function setHiddenFormProductoRiel(params) {
  updateHiddenFormProduct(hidden_form_producto_riel_madera, params);
}

function setHiddenFormProductoRodillo(params) {
  updateHiddenFormProduct(hidden_form_producto_rodillo_madera, params);
}

function setHiddenFormProductoTapa(params) {
  updateHiddenFormProduct(hidden_form_producto_tapa_madera, params);
}

function setHiddenFormProductoVarilla(params) {
  updateHiddenFormProduct(hidden_form_producto_varilla_madera, params);
}

function setHiddenFormProductoInstalacion(params) {
  updateHiddenFormProduct(hidden_form_producto_instalacion_madera, params);
}

// hidden Products Madera
function getHiddenProductoLamaMadera() {
  let sku = "";
  let skuValue = "";
  if (document.querySelector("input[name='tela-opcion-colores']:checked") !== null) {
    skuValue = document.querySelector("input[name='tela-opcion-colores']:checked").dataset.sku;
    sku = `[data-product-sku='${skuValue}']`;
  }

  const storeFilters = {
    productColor: form_cotizado_tela_opcion_color.value
  };

  if (skuValue) {
    storeFilters.productSku = skuValue;
  }

  const current_checked =
    document.querySelector(`.madera-products .product-lama-madera${sku}[data-product-color='${form_cotizado_tela_opcion_color.value}']`)
    || document.querySelector(`.madera-products .product-lama-madera[data-product-color='${form_cotizado_tela_opcion_color.value}']`);
  if (current_checked) {
    return current_checked;
  }

  return findMaderaLamaProductsFromStore(storeFilters)[0] || null;
}

function getDescripcionSoftlandFromSelectionMadera() {
  const selectedProduct = getHiddenProductoLamaMadera();
  if (selectedProduct && selectedProduct.dataset) {
    return (selectedProduct.dataset.descripcionSoftland || "").trim();
  }
  return "";
}

function calculaCotizacion() {
  let total                   = getTotal();
  let total_precio            = total.toString().replace(MONEY_REGEX, ".");
  total_precio_input.value    = total
  total_precio_html.innerHTML = `$${total_precio}`;
}

function getNumericInputValue(input, label = "unknown-input") {
  if (!input) {
    return 99999;
  }

  const parsed = parseInt(input.value, 10);
  if (Number.isNaN(parsed)) {
    return 99999;
  }

  return parsed;
}

function getTotal() {
  // Productos Tradicionales
  let sumaResto       = calculateSumaResto();

  let bracket_central = getNumericInputValue(hidden_form_producto_bracket_central_madera);
  let bracket_lateral = getNumericInputValue(hidden_form_producto_bracket_lateral_madera);
  let clip_cenefa     = getNumericInputValue(hidden_form_producto_clip_cenefa_madera);
  let madera_2        = getNumericInputValue(hidden_form_producto_madera_2_madera);
  let tapa            = getNumericInputValue(hidden_form_producto_tapa_madera);
  let borla           = getNumericInputValue(hidden_form_producto_borla_madera);
  let clip_2          = getNumericInputValue(hidden_form_producto_clip_2_madera);
  let base            = getNumericInputValue(hidden_form_producto_base_madera);
  let boton_escalera  = getNumericInputValue(hidden_form_producto_boton_escalera_madera);
  let boton           = getNumericInputValue(hidden_form_producto_boton_madera);
  let madera_1        = getNumericInputValue(hidden_form_producto_madera_1_madera);
  let rodillo         = getNumericInputValue(hidden_form_producto_rodillo_madera);
  let piola           = getNumericInputValue(hidden_form_producto_piola_madera);
  let lama            = getNumericInputValue(hidden_form_producto_lama_madera);
  let cabezal         = getNumericInputValue(hidden_form_producto_cabezal_madera);
  let cuerda          = getNumericInputValue(hidden_form_producto_cuerda_madera);
  let confeccion      = getNumericInputValue(hidden_form_producto_confeccion_madera);
  let instalacion     = getNumericInputValue(hidden_form_producto_instalacion_madera);

  let total           = Math.round(sumaResto + bracket_central + bracket_lateral + clip_cenefa + madera_2 + tapa + borla + clip_2 + base + boton_escalera + boton + madera_1 + rodillo + piola + lama + cabezal + cuerda + confeccion + instalacion);

  return total;
}

function getFormQuote() {
  // Cotizador Tradicional
  let quoteText    = "";

  quoteText = `<h3 class="inner-title">Resumen Productos </h3>
    <div class="line line-sku"><span class="var var-title">Anillo:</span><span class="val val-sku"> ${hidden_form_producto_anillo_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Barra:</span><span class="val val-sku"> ${hidden_form_producto_barra_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Base:</span><span class="val val-sku"> ${hidden_form_producto_base_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Borla:</span><span class="val val-sku"> ${hidden_form_producto_borla_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Botón:</span><span class="val val-sku"> ${hidden_form_producto_boton_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Botón Escalera:</span><span class="val val-sku"> ${hidden_form_producto_boton_escalera_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Bracket Central:</span><span class="val val-sku"> ${hidden_form_producto_bracket_central_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Bracket Lateral:</span><span class="val val-sku"> ${hidden_form_producto_bracket_lateral_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Cabezal:</span><span class="val val-sku"> ${hidden_form_producto_cabezal_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Cenefa:</span><span class="val val-sku"> ${hidden_form_producto_cenefa_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Clip 1:</span><span class="val val-sku"> ${hidden_form_producto_clip_1_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Clip 2:</span><span class="val val-sku"> ${hidden_form_producto_clip_2_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Clip Cenefa:</span><span class="val val-sku"> ${hidden_form_producto_clip_cenefa_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Cuerda:</span><span class="val val-sku"> ${hidden_form_producto_cuerda_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Freno:</span><span class="val val-sku"> ${hidden_form_producto_freno_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Lama:</span><span class="val val-sku"> ${hidden_form_producto_lama_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Madera 1:</span><span class="val val-sku"> ${hidden_form_producto_madera_1_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Madera 2:</span><span class="val val-sku"> ${hidden_form_producto_madera_2_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Piola:</span><span class="val val-sku"> ${hidden_form_producto_piola_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Riel:</span><span class="val val-sku"> ${hidden_form_producto_riel_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Rodillo:</span><span class="val val-sku"> ${hidden_form_producto_rodillo_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Tapa:</span><span class="val val-sku"> ${hidden_form_producto_tapa_madera.dataset.productSku}</span></div>
    <div class="line line-sku"><span class="var var-title">Varilla:</span><span class="val val-sku"> ${hidden_form_producto_varilla_madera.dataset.productSku}</span></div>`;

  if (hidden_form_producto_instalacion_madera.value !== "0" && hidden_form_producto_instalacion_madera.value !== "") {
    quoteText += `<div class="line line-sku"><span class="var var-title">Instalación Región:</span><span class="val val-sku"> ${form_cotizado_instalacion_region.value}</span></div>
      <div class="line line-sku"><span class="var var-title">Instalación Comuna:</span><span class="val val-sku"> ${form_cotizado_instalacion_comuna.value}</span></div>
      <div class="line line-sku"><span class="var var-title">Instalación Dirección:</span><span class="val val-sku"> ${form_cotizado_instalacion_direccion.value}</span></div>`;
  }

  quoteText += `
    <div class="line line-sku"><span class="var var-title">Nombre:</span><span class="val val-sku"> ${form_cotizado_nombre.value}</span></div>
    <div class="line line-sku"><span class="var var-title">Mensaje:</span><span class="val val-instalacion-cortina"> ${form_cotizado_mensaje.value}</span></div>
    <div class="line line-sku last"><span class="var var-title">Código:</span><span class="val val-codigo"> ${form_cotizado_homologado_venta.value}</span></div>`;

  return quoteText;
}

function setImagePreview({ input }) {
  if (input) {
    const { productImage, productImageZoom, productImageExtra, productImageExtraZoom } = input.dataset;

    // Actualizar imagen principal
    preview_image.src = productImage;
    preview_image.srcset = productImage;
    preview_image.parentElement.href = productImageZoom;

    // Actualizar imagen extra
    preview_image_zoom.src = productImageExtra;
    preview_image_zoom.srcset = productImageExtra;
    preview_image_zoom.parentElement.href = productImageExtraZoom;

    $('.easyzoom').each(function() {
      const easyzoomInstance = $(this).data('easyZoom');
      easyzoomInstance.teardown();
      $(this).easyZoom({
        loadingNotice: 'Cargando imagen'
      });
    });
  }
}

// Calculo Madera
function calculateSumaResto() {
  // A - (E4     + E5    + E6     + E7     + E8    + E9   + E10)
  // A - (Anillo + Barra + Cenefa + Clip 1 + Freno + Riel + Varilla)
  return (
    getNumericInputValue(hidden_producto_anillo_madera, "hidden_producto_anillo_madera") +
    getNumericInputValue(hidden_producto_barra_madera, "hidden_producto_barra_madera") +
    getNumericInputValue(hidden_producto_cenefa_madera, "hidden_producto_cenefa_madera") +
    getNumericInputValue(hidden_producto_clip_1_madera, "hidden_producto_clip_1_madera") +
    getNumericInputValue(hidden_producto_freno_madera, "hidden_producto_freno_madera") +
    getNumericInputValue(hidden_producto_riel_madera, "hidden_producto_riel_madera") +
    getNumericInputValue(hidden_producto_varilla_madera, "hidden_producto_varilla_madera")
  );
}

function calculateBracketCentral(params) {
  // B - (E11             * 2)
  // B - (Bracket Central * 2)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 2);
    setHiddenFormProducto(hidden_form_producto_bracket_central_madera, {"input": input, "value": total});
  }
}

function calculateBracketLateral(params) {
  // C - (E12             * 2)
  // C - (Bracket Lateral * 2)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 2);
    setHiddenFormProducto(hidden_form_producto_bracket_lateral_madera, {"input": input, "value": total});
  }
}

function calculateClipCenefa(params) {
  // D - (E13         * 2)
  // D - (Clip Cenefa * 2)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 2);
    setHiddenFormProducto(hidden_form_producto_clip_cenefa_madera, {"input": input, "value": total});
  }
}

function calculateMadera2(params) {
  // E - (E14      * 2)
  // E - (Madera 2 * 2)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 2);
    setHiddenFormProducto(hidden_form_producto_madera_2_madera, {"input": input, "value": total});
  }
}

function calculateTapa(params) {
  // F - (E15  * 2)
  // F - (Tapa * 2)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 2);
    setHiddenFormProducto(hidden_form_producto_tapa_madera, {"input": input, "value": total});
  }
}

function calculateBorla(params) {
  // G - (E16   * 3)
  // G - (Borla * 3)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 3);
    setHiddenFormProducto(hidden_form_producto_borla_madera, {"input": input, "value": total});
  }
}

function calculateClip2(params) {
  // H - (E17    * 3)
  // H - (Clip 2 * 3)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 3);
    setHiddenFormProducto(hidden_form_producto_clip_2_madera, {"input": input, "value": total});
  }
}

function calculateBase(params) {
  // I - (E18  * 5)
  // I - (Base * 5)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 5);
    setHiddenFormProducto(hidden_form_producto_base_madera, {"input": input, "value": total});
  }
}

function calculateRodillo(params) {
  // J - (E22     * 5)
  // J - (Rodillo * 5)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 5);
    setHiddenFormProducto(hidden_form_producto_rodillo_madera, {"input": input, "value": total});
  }
}

function calculatePiola(params) {
  // K - (E23   * (4 * G5)   + (2 * H4))
  // K - (Piola * (4 * Alto) + (2 * Ancho))
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * (4 * (parseFloat(form_cotizado_alto.value / 100))) + (2 * (parseFloat(form_cotizado_ancho.value) / 100)));
    setHiddenFormProducto(hidden_form_producto_piola_madera, {"input": input, "value": total});
  }
}

function calculateLama(params) {
  // L - (E24  * H4    * (G5   / 0.045) * (1 + G1))
  // L - (Lama * Ancho * (Alto / 0.045) * (1 + Merma [20%]))
  let input = params["input"];
  if (input && input.value !== undefined) {

    setImagePreview({"input": input});
    let total = Math.round(parseFloat(input.value) * (parseFloat(form_cotizado_ancho.value) / 100) * ((parseFloat(form_cotizado_alto.value) / 100) / 0.045) * (1 + (20 / 100)));
    setHiddenFormProducto(hidden_form_producto_lama_madera, {"input": input, "value": total});
  }
}

function calculateCabezal(params) {
  // M - (E25     * H4    * (1 + G1))
  // M - (Cabezal * Ancho * (1 + Merma [20%]))
  let input = params["input"];
  if (input !== null) {
    let total = parseFloat(input.value) * (parseFloat(form_cotizado_ancho.value) / 100) * (1 + (20 / 100));
    setHiddenFormProducto(hidden_form_producto_cabezal_madera, {"input": input, "value": total});
  }
}

function calculateCuerda(params) {
  // N - (E26    * 2 * G5)
  // N - (Cuerda * 2 * Alto)
  let input = params["input"];
  if (input !== null) {
    let quantity = 2;

    if (parseInt(form_cotizado_ancho.value) >= 100) {
      quantity = 3;
    }

    let total = parseFloat(input.value) * quantity * (parseFloat(form_cotizado_alto.value) / 100);
    setHiddenFormProducto(hidden_form_producto_cuerda_madera, {"input": input, "value": total});
  }
}

function calculateConfeccion(params) {
  // O - (H2    * H4    * G5)
  // O - (Costo * Ancho * Alto)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * (parseFloat(form_cotizado_ancho.value) / 100) * (parseFloat(form_cotizado_alto.value) / 100));
    setHiddenFormProducto(hidden_form_producto_confeccion_madera, {"input": input, "value": total});
  }
}

function calculateBotonEscalera(params) {
  // P - (E19 * 5)
  // P - (Botón Escalera * 5)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 5);
    setHiddenFormProducto(hidden_form_producto_boton_escalera_madera, {"input": input, "value": total});
  }
}

function calculateBoton(params) {
  // Q - (E20   * 5)
  // Q - (Botón * 5)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 5);
    setHiddenFormProducto(hidden_form_producto_boton_madera, {"input": input, "value": total});
  }
}

function calculateMadera1(params) {
  // R - (E21      * 5)
  // R - (Madera 1 * 5)
  let input = params["input"];
  if (input !== null) {
    let total = Math.round(parseFloat(input.value) * 5);
    setHiddenFormProducto(hidden_form_producto_madera_1_madera, {"input": input, "value": total});
  }
}

function calculateTotalWeight(params) {
  let anillo          = params["anillo"];
  let barra           = params["barra"];
  let base            = params["base"];
  let borla           = params["borla"];
  let boton           = params["boton"];
  let boton_escalera  = params["boton_escalera"];
  let bracket_central = params["bracket_central"];
  let bracket_lateral = params["bracket_lateral"];
  let cabezal         = params["cabezal"];
  let cenefa          = params["cenefa"];
  let clip_1          = params["clip_1"];
  let clip_2          = params["clip_2"];
  let clip_cenefa     = params["clip_cenefa"];
  let cuerda          = params["cuerda"];
  let freno           = params["freno"];
  let lama            = params["lama"];
  let madera_1        = params["madera_1"];
  let madera_2        = params["madera_2"];
  let piola           = params["piola"];
  let riel            = params["riel"];
  let rodillo         = params["rodillo"];
  let tapa            = params["tapa"];
  let varilla         = params["varilla"];

  let peso            = 0;
  if (anillo !== null && barra !== null && base !== null && borla !== null && boton !== null && boton_escalera !== null && bracket_central !== null && bracket_lateral !== null && cabezal !== null && cenefa !== null && clip_1 !== null && clip_2 !== null && clip_cenefa !== null && cuerda !== null && freno !== null && lama !== null && madera_1 !== null && madera_2 !== null && piola !== null &&  riel !== null && rodillo !== null && tapa !== null && varilla !== null) {
    peso = (parseInt(anillo.dataset.productWeight) + parseInt(barra.dataset.productWeight) + parseInt(base.dataset.productWeight) + parseInt(borla.dataset.productWeight) + parseInt(boton.dataset.productWeight) + parseInt(boton_escalera.dataset.productWeight) + parseInt(bracket_central.dataset.productWeight) + parseInt(bracket_lateral.dataset.productWeight) + parseInt(cabezal.dataset.productWeight) + parseInt(cenefa.dataset.productWeight) + parseInt(clip_1.dataset.productWeight) + parseInt(clip_2.dataset.productWeight) + parseInt(clip_cenefa.dataset.productWeight) + parseInt(cuerda.dataset.productWeight) + parseInt(freno.dataset.productWeight) + parseInt(madera_1.dataset.productWeight) + parseInt(madera_2.dataset.productWeight) + parseInt(piola.dataset.productWeight) + parseInt(riel.dataset.productWeight) + parseInt(rodillo.dataset.productWeight) + parseInt(tapa.dataset.productWeight) + parseInt(varilla.dataset.productWeight) + (parseInt(lama.dataset.productWeight) * Math.ceil(input_ancho.value / 100))) / 1000;
    setHiddenFormProductoPesoEnvio({"value": peso, "grams": peso * 1000});
  }
}

// Submit Cotizador
async function submitCotizacion() {
  if (validateForm()) {
    try {
    closeAllTitles();
    let formQuote    = getFormQuote();
    let disclaimer   = document.querySelector(".quote-disclaimer").innerHTML;
    let tela_title   = form_cotizado_tela_tipo.dataset.value;
    let peso         = parseInt(hidden_form_producto_peso_envio_madera.value);
    let peso_gramos  = parseInt(hidden_form_producto_peso_envio_madera.dataset.grams);
    const descripcionSoftland = getDescripcionSoftlandFromSelectionMadera();

    let body_html = `
      <div class="resumen">
        <h3 class="inner-title">Resumen Cotización:<span class="val-cortina-tipo"> ${form_cotizado_cortina_tipo.dataset.value} - ${form_cotizado_nombre.value}</span></h3>
        <div class="line line-product"><span class="var">Ancho:</span><span class="val val-ancho"> ${form_cotizado_ancho.value} cm</span></div>
        <div class="line line-product"><span class="var">Alto:</span><span class="val val-alto"> ${form_cotizado_alto.value} cm</span></div>
        <div class="line line-product"><span class="var">Persiana:</span><span class="val val-tela-tipo"> ${tela_title}</span></div>
        <div class="line line-product"><span class="var">Color Persiana:</span><span class="val val-tela-suboption"> ${form_cotizado_tela_opcion_color.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Descripción Softland:</span><span class="val val-descripcion-softland"> ${descripcionSoftland}</span></div>
        <div class="line line-product"><span class="var">Posición del mando:</span><span class="val val-posicion-mando"> ${form_cotizado_mando_posicion.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Instalación a domicilio:</span><span class="val val-instalacion"> ${form_cotizado_instalacion.dataset.value}</span></div>
        <div class="line line-product last"><span class="var">Cantidad:</span><span class="val val-quantity"> xxxxx</span></div>
        <div class="bottom">
          <h6 class="precio precio-total">Total: <span>${total_precio_html.innerHTML}</span></h6>
          <p class="red">${disclaimer}</p>
        </div>
        <div class="resumen-p">
          ${formQuote}
        </div>
      </div>`;

    const storeCode = (typeof getCotizadorStoreCode === "function" && getCotizadorStoreCode()) || (window.Shopify.shop || "").split(".")[0];
    const customerEmail = (typeof getCotizadorStoreEmailFallback === "function" && getCotizadorStoreEmailFallback()) || `cotizador@${window.Shopify.shop}`;
    const totalPrice = Number(total_precio_input.value || 0);

    const quotePayload = {
      store: storeCode,
      customerName: form_cotizado_nombre.value || "Cliente Cotizador",
      customerEmail,
      currency: "CLP",
      priceList: "LA",
      notes: form_cotizado_mensaje.value || null,
      items: (typeof buildQuoteItemsFromHiddenProducts === "function" ? buildQuoteItemsFromHiddenProducts(document) : [])
    };

    const tempProductPayload = {
      store: storeCode,
      title: `Cotización - ${form_cotizado_nombre.value}`,
      price: totalPrice,
      currency: "CLP",
      sku: form_cotizado_homologado_venta.value || "COTIZA-B2C",
      quantity: 1,
      descriptionHtml: body_html
    };

    await processCotizadorQuoteTempProductCart({
      quotePayload,
      tempProductPayload,
      quantity: 1
    }, { container: cotiza_container });
    hidden_cotizacion_area.innerHTML = hidden_cotizacion_area.innerHTML + body_html + "<br><br>";
    document.querySelector(".btn.print").classList.add("show");
    document.querySelector(".btn.email").classList.add("show");
    } catch (error) {
      const quoteContext = (error && error.message) ? error.message : "sin contexto";
      console.error("Error en flujo v3 cotizador (quote/temp-product/cart)", quoteContext, error);
      if (typeof showCotizadorFunctionalError === "function") {
        showCotizadorFunctionalError("No se pudo procesar la cotización en este momento.");
      }
    }
  }
}

async function syncThemeCartUIFeedback() {
  try {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: "GET",
      credentials: "include"
    });
    const cartState = await cartResponse.json();

    if (typeof window.emit === "function") {
      window.emit("quick-cart:updated");
      window.emit("cart:updated", { cart: cartState });
    }

    document.dispatchEvent(new CustomEvent("quick-cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartState } }));
  } catch (error) {
    console.error("No se pudo sincronizar feedback UI del carrito", error);
  }
}

function validateForm() {
  const TITLE_SELECTOR = ".title-select-h1[data-option-number='{num}']";
  const SUBTITLE_SELECTOR = ".title-select-h4[data-option-number='{num}']";

  const validations = [
    {
      condition: () => form_cotizado_cortina_tipo.value.length == 0,
      focusElement: input_cortina_tipos[0]
    },
    {
      condition: () => form_cotizado_ancho.value.length == 0 || parseInt(form_cotizado_ancho.value) < input_ancho.min || parseInt(form_cotizado_ancho.value) > input_ancho.max,
      focusElement: input_ancho,
      title: TITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_alto.value.length == 0 || parseInt(form_cotizado_alto.value) < input_alto.min || parseInt(form_cotizado_alto.value) > input_alto.max,
      focusElement: input_alto,
      title: TITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_tela_tipo.value.length == 0,
      focusElement: input_tela_tipos[0],
      title: TITLE_SELECTOR.replace('{num}', '2')
    },
    {
      condition: () => form_cotizado_tela_suboption.value.length == 0,
      focusElement: input_tela_suboptions[0],
      title: TITLE_SELECTOR.replace('{num}', '2'),
      subtitle: SUBTITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_tela_opcion_color.value.length == 0,
      focusElement: document.querySelector("input[name='tela-opcion-colores']") || input_tela_opcion_colores[0],
      title: TITLE_SELECTOR.replace('{num}', '2'),
      subtitle: SUBTITLE_SELECTOR.replace('{num}', '1')
    },
    {
      condition: () => form_cotizado_mando_posicion.value.length == 0,
      focusElement: input_mando_posiciones[0],
      title: TITLE_SELECTOR.replace('{num}', '5')
    },
    {
      condition: () => region_select.value === '1' && region_direccion.value.length === 0 && parseInt(form_cotizado_instalacion.value) !== 0,
      focusElement: input_instalacion_direccion,
      title: TITLE_SELECTOR.replace('{num}', '8')
    },
    {
      condition: () => form_cotizado_nombre.value.length == 0 || form_cotizado_nombre.value.length > input_nombre.maxLength,
      focusElement: input_nombre,
      title: TITLE_SELECTOR.replace('{num}', '9')
    },
    {
      condition: () => form_cotizado_mensaje.value.length == 0 || form_cotizado_mensaje.value.length > input_mensaje.maxLength,
      focusElement: input_mensaje,
      title: TITLE_SELECTOR.replace('{num}', '9')
    }
  ];

  for (let validation of validations) {
    if (validation.condition()) {
      closeAllTitles();

      if (validation.title) {
        openTitle(document.querySelector(validation.title));
      }

      if (validation.subtitle) {
        openSubtitle(document.querySelector(validation.subtitle));
      }

      validation.focusElement.focus();
      return false;
    }
  }

  return true;
}

function getMultiplier() {
  let tipo_cortina = document.querySelector("input[name='tipo-cortinas']:checked").dataset.value;
  let multiplier   = 1;
  if (tipo_cortina === "tres-pliegues") {
    multiplier = 3;
  } else if (tipo_cortina === "presilla") {
    multiplier = 2;
  } else if (tipo_cortina === "presillas-pliegue") {
    multiplier = 2.5;
  }

  return multiplier;
}

function indexInParent(node) {
  let children = node.parentNode.childNodes;
  let num      = 0;
  for (let i = 0; i < children.length; i++) {
      if (children[i] === node) return num;
      if (children[i].nodeType === 1) num++;
  }
  return -1;
}

function findGetParameter(parameterName) {
  var result = null, tmp = [];
  location.search.substr(1).split("&").forEach(function(item) {
    tmp = item.split("=");
    if (tmp[0] === parameterName) {
      result = decodeURIComponent(tmp[1]);
    }
  });
  return result;
}

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true, quote = false) {
  let cotizacion_total = 0;
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i]["product_type"] == "Cotiza Cortina") {
        quote = true;
      }
      if (quote) {
        cotizacion_total += parseFloat(data.items[i]["final_line_price"]);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    if (quote || total == 0) {
      var cotización_total_format = cotizacion_total ? cotizacion_total.toString().substring(0, cotizacion_total.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      $(".inner-cotizacion-total span").html('$' + cotización_total_format);
      if (cotizacion_total == 0) {
        $(".btn.print").removeClass("show");
        $(".inner-cotizacion-content").empty();
      }
    }
  }, 'json');
}

var $easyzoom = $('.easyzoom').easyZoom({
  loadingNotice: 'Cargando imagen'
});
